import React, { useMemo } from "react";
import styled from "styled-components";
import { isPermitted } from "util/PermissionsMixin";
import { Button } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import { Row } from "common/components";
import useCurrentUser from "hooks/useCurrentUser";
import { TD } from "security-app/components/common";
import SetStatusControl from "security-app/components/SecurityEvents/Alerts/EventDetails/SetStatusControl";
import Routes from "routing/Routes";
import { LinkContainer } from "components/common";
import OwnerAction from "security-app/components/SecurityEvents/Alerts/EventDetails/OwnerAction";
const RowCol = styled(Row)`
  flex-direction: ${({ $orientation }) => $orientation === "vert" ? "column" : "row"};
`;
function ActionsRow({ securityEvent, orientation = "horz", showReplayAction = true }) {
  const { setModal, setEntity } = useModalContext();
  const { permissions } = useCurrentUser();
  const hideReplayAction = useMemo(
    () => !showReplayAction || !!securityEvent.event.event_definition_type.match(/system-notification/i) || !securityEvent.event.replay_info,
    [securityEvent.event.event_definition_type, securityEvent.event.replay_info, showReplayAction]
  );
  const canManageSecurityEvents = useMemo(() => isPermitted(permissions, "security_event:edit"), [permissions]);
  const openEvidenceModal = () => {
    const { event } = securityEvent;
    setEntity([event.id]);
    setModal("ADD-EVIDENCE");
  };
  const sendNotification = () => {
    setEntity(securityEvent);
    setModal("SEND-NOTIFICATION");
  };
  const onStatusChange = (newStatus) => {
    if (newStatus !== securityEvent.status) {
      setEntity({ securityEvent, newStatus });
      setModal("CONFIRM-STATUS-CHANGE");
    }
  };
  return /* @__PURE__ */ React.createElement(RowCol, { $orientation: orientation }, /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-start", $gap: "md" }, hideReplayAction || /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.ALERTS.replay_search(securityEvent.event_id), target: "_blank" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "sm" }, "Replay Search")), !canManageSecurityEvents || /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: openEvidenceModal }, "Add to an Investigation"), !canManageSecurityEvents || /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: sendNotification }, "Send Notification")), /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-end", $gap: "xl" }, canManageSecurityEvents ? /* @__PURE__ */ React.createElement(OwnerAction, { securityEvent }) : /* @__PURE__ */ React.createElement(TD, null), /* @__PURE__ */ React.createElement(Row, { $align: "center", $width: "auto" }, /* @__PURE__ */ React.createElement(
    SetStatusControl,
    {
      onStatusChange,
      value: securityEvent.status,
      disabled: !canManageSecurityEvents
    }
  ))));
}
export default ActionsRow;
